import type * as React from 'react'

import { Spinner } from '../components/ui/spinner'
import { cn } from '../lib/utils'

/** Área carregando: spinner centralizado com um texto curto. Para listas e
 *  cards com formato conhecido, prefira `Skeleton`. */
function LoadingState({
  label = 'Carregando...',
  className,
}: {
  label?: React.ReactNode
  className?: string
}) {
  return (
    <div
      role="status"
      className={cn(
        'text-muted-foreground flex items-center justify-center gap-2 py-12 text-sm',
        className
      )}
    >
      <Spinner />
      {label}
    </div>
  )
}

export { LoadingState }
